 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"component---cache-caches-gatsby-plugin-offline-app-shell-js","5":"component---src-pages-404-mdx","6":"component---src-pages-about-mdx","7":"component---src-pages-accessibility-mdx","8":"component---src-pages-downloads-disbursements-by-month-mdx","9":"component---src-pages-downloads-disbursements-mdx","10":"component---src-pages-downloads-federal-revenue-by-company-mdx","11":"component---src-pages-downloads-federal-sales-mdx","12":"component---src-pages-downloads-index-mdx","13":"component---src-pages-downloads-production-by-disposition-mdx","14":"component---src-pages-downloads-production-by-month-mdx","15":"component---src-pages-downloads-production-mdx","16":"component---src-pages-downloads-revenue-mdx","17":"component---src-pages-explore-index-mdx","18":"component---src-pages-explore-offshore-regions-alaska-mdx","19":"component---src-pages-explore-offshore-regions-atlantic-mdx","20":"component---src-pages-explore-offshore-regions-gulf-mdx","21":"component---src-pages-explore-offshore-regions-pacific-mdx","22":"component---src-pages-explore-states-ak-mdx","23":"component---src-pages-explore-states-al-mdx","24":"component---src-pages-explore-states-ar-mdx","25":"component---src-pages-explore-states-az-mdx","26":"component---src-pages-explore-states-ca-mdx","27":"component---src-pages-explore-states-co-mdx","28":"component---src-pages-explore-states-fl-mdx","29":"component---src-pages-explore-states-id-mdx","30":"component---src-pages-explore-states-il-mdx","31":"component---src-pages-explore-states-in-mdx","32":"component---src-pages-explore-states-ks-mdx","33":"component---src-pages-explore-states-ky-mdx","34":"component---src-pages-explore-states-la-mdx","35":"component---src-pages-explore-states-md-mdx","36":"component---src-pages-explore-states-mi-mdx","37":"component---src-pages-explore-states-mn-mdx","38":"component---src-pages-explore-states-mo-mdx","39":"component---src-pages-explore-states-ms-mdx","40":"component---src-pages-explore-states-mt-mdx","41":"component---src-pages-explore-states-nc-mdx","42":"component---src-pages-explore-states-nd-mdx","43":"component---src-pages-explore-states-ne-mdx","44":"component---src-pages-explore-states-nm-mdx","45":"component---src-pages-explore-states-nv-mdx","46":"component---src-pages-explore-states-ny-mdx","47":"component---src-pages-explore-states-oh-mdx","48":"component---src-pages-explore-states-ok-mdx","49":"component---src-pages-explore-states-or-mdx","50":"component---src-pages-explore-states-pa-mdx","51":"component---src-pages-explore-states-sc-mdx","52":"component---src-pages-explore-states-sd-mdx","53":"component---src-pages-explore-states-tx-mdx","54":"component---src-pages-explore-states-ut-mdx","55":"component---src-pages-explore-states-va-mdx","56":"component---src-pages-explore-states-wa-mdx","57":"component---src-pages-explore-states-wi-mdx","58":"component---src-pages-explore-states-wv-mdx","59":"component---src-pages-explore-states-wy-mdx","60":"component---src-pages-fact-sheet-mdx","61":"component---src-pages-glossary-mdx","62":"component---src-pages-how-revenue-works-aml-reclamation-program-mdx","63":"component---src-pages-how-revenue-works-audits-and-assurances-mdx","64":"component---src-pages-how-revenue-works-coal-excise-tax-mdx","65":"component---src-pages-how-revenue-works-coal-mdx","66":"component---src-pages-how-revenue-works-disbursements-mdx","67":"component---src-pages-how-revenue-works-federal-laws-mdx","68":"component---src-pages-how-revenue-works-federal-reforms-mdx","69":"component---src-pages-how-revenue-works-gomesa-mdx","70":"component---src-pages-how-revenue-works-hpf-mdx","71":"component---src-pages-how-revenue-works-index-mdx","72":"component---src-pages-how-revenue-works-lwcf-mdx","73":"component---src-pages-how-revenue-works-minerals-mdx","74":"component---src-pages-how-revenue-works-native-american-ownership-governance-mdx","75":"component---src-pages-how-revenue-works-native-american-production-mdx","76":"component---src-pages-how-revenue-works-native-american-revenue-mdx","77":"component---src-pages-how-revenue-works-offshore-oil-gas-mdx","78":"component---src-pages-how-revenue-works-offshore-renewables-mdx","79":"component---src-pages-how-revenue-works-onshore-oil-gas-mdx","80":"component---src-pages-how-revenue-works-onshore-renewables-mdx","81":"component---src-pages-how-revenue-works-ownership-mdx","82":"component---src-pages-how-revenue-works-reclamation-mdx","83":"component---src-pages-how-revenue-works-revenues-mdx","84":"component---src-pages-index-mdx","85":"component---src-pages-information-quality-mdx","86":"component---src-pages-patterns-components-index-mdx","87":"component---src-pages-patterns-index-mdx","88":"component---src-pages-patterns-visual-styles-color-mdx","89":"component---src-pages-patterns-visual-styles-iconography-mdx","90":"component---src-pages-patterns-visual-styles-typography-mdx","91":"component---src-pages-plain-language-mdx","92":"component---src-pages-query-data-mdx","93":"component---src-pages-search-results-mdx","94":"component---src-pages-vdp-mdx"}[chunkId]||chunkId) + "-" + {"4":"6ee1700e433cfdf3ee02","5":"db42aa89d20df94a2510","6":"6f2c654d789293841508","7":"24251c7d4b8f0f967478","8":"79e00c507daa966eeed1","9":"0311a0e63ef683a4c326","10":"12d1a5393b5b09fce004","11":"5dee26c2536c4585a4de","12":"b35942d5fc491fe7bef9","13":"48885fce1245068a2e62","14":"4751763c600b716dc213","15":"bfe1bf317bcd287adfed","16":"e8c97d0a4a609dd86ba3","17":"48ab77f275f27e15ec31","18":"3b9864ae1ec21dceb416","19":"356bf662094d21661dd8","20":"c64c61e7714a3302ba2d","21":"e69e50af1042891a844d","22":"aa783a2a39ab555dd7a9","23":"16276039015c14d07661","24":"a42b8ea65c27843a18d6","25":"da311ed2e655e2081164","26":"a30aad0c47f9e1a665c8","27":"269e0b249a8ced4b2e0b","28":"377a01ff4f0397acea5e","29":"cd3be7eac02fca2da7f2","30":"2bb038277a907a443482","31":"6de182531c544755bdb6","32":"055e06f4dfb95b49f7bc","33":"6097a44d33533eb87c42","34":"9c4019eb528ba29d3470","35":"af426be3c0bfec8379bb","36":"227b989c2efe8b466f03","37":"9d57a3c8305807e58037","38":"572428d70de323dd222c","39":"719b9f940a0a760580fb","40":"5c51b25f7c066629a8c7","41":"8b946be4cbcc51c8988a","42":"fe622b813d8a9d76d5f6","43":"c02746ee64e07d1c5499","44":"d92d1a73e81b996b2043","45":"b722966604a689b48260","46":"ae031dd21e87437dab59","47":"6661478761dd16b64e24","48":"b698216ff8505aa7234c","49":"5adc01dabe61deae36a7","50":"773010727636bdd9f19c","51":"faf0028d026d5caec946","52":"dea826e9239d3dc45bb5","53":"8f6ced0262682dce4875","54":"44f34b99f8397f363782","55":"cb2bcc967a8e377067d0","56":"76ee585cdf0110aa53dc","57":"3d1969fda6cfdf7eaa38","58":"5a933942ce1321636d2a","59":"25fcc5a94534962df512","60":"6377ec9e1de829df4347","61":"b29629f86efeb0063af9","62":"fa95560c637ee8872311","63":"efbfba9c3dfafde68bb8","64":"f31ac43b3313b4411410","65":"242ad8a473c562e70cb4","66":"af460d9674e2ac8f724a","67":"3f43c4c2e9543f8124b3","68":"caa1b80814e80b71cd90","69":"4cb36a22359159bb3128","70":"01da5c6f30b63540b23e","71":"5ba283abe2361654eed0","72":"4709f7ddf413927a9177","73":"a921edc2eebceb5c3156","74":"eb090ebd7ed82e5716c8","75":"ba7eae5f1f4cb1d4d214","76":"bfa96773012951572a06","77":"ca03b35e2b064a392834","78":"7f184423e0906c01716d","79":"597dec0321ee58564a52","80":"356fdd7849263e393c91","81":"808652149fc13d0d14da","82":"e3122b164f9ed58e5d2a","83":"794c6c5f7ffd294eb7c6","84":"f8c371b91681e66cc47b","85":"6f1d721ee631d52e5cf8","86":"167be82dd56c34e4f7da","87":"851659bac62b8aaa3dfb","88":"4c5766e1d5dd5a0a6532","89":"b284b1a7e9bd0a2c7f50","90":"b318b55ddb0bcc66efe7","91":"a5e425be41cb470019d3","92":"7a54785fb1c774c49b64","93":"a2ee5aff691b3870cdfc","94":"ebf889cb87073ae2ddb7","99":"1bd523453522d8e2b975","100":"53b393e8e62c60fb148a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sites/GOMESA/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
